var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"ma-3 d-flex justify-center align-center",attrs:{"outlined":"","type":"info"}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t(_vm.messageKey))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }